import OneSignal from "react-onesignal";

let oneSignalAlreadyInitialized = false;

export const initOneSignal = async () => {
  if (oneSignalAlreadyInitialized) {
    console.log("OneSignal já foi inicializado");
    return;
  }

  try {
    await OneSignal.init({
      appId: "53e9f96b-64af-468f-8a1a-7e6f96c4cd86",
      notifyButton: { enable: false },
      allowLocalhostAsSecureOrigin: true,
      serviceWorkerPath: "/OneSignalSDKWorker.js",
      serviceWorkerParam: { scope: "/" },
      promptOptions: {
        slidedown: {
          prompts: [
            {
              type: "push",
              autoPrompt: false, // Controlamos manualmente
            },
          ],
        },
      },
    });

    oneSignalAlreadyInitialized = true;
    console.log("OneSignal inicializado com sucesso");
  } catch (error) {
    console.error("Falha ao inicializar OneSignal:", error);
  }
};

export const setupOneSignalUser = async (uid) => {
  try {
    await initOneSignal();

    // Primeiro verifica se já tem permissão
    const permission = await window.OneSignal.Notifications.permission;
    console.log("Push notifications permission:", permission);

    // Configura os listeners de mudança de permissão
    window.OneSignal.Notifications.addEventListener(
      "permissionChange",
      async (event) => {
        console.log("Permissão mudou para:", event.to);
        if (event.to === true) {
          // Só faz login depois que a permissão for concedida
          await window.OneSignal.login(`upbot_${uid}`);
          console.log(
            "External user ID configurado após permissão:",
            `upbot_${uid}`
          );
        }
      }
    );

    if (permission === true) {
      // Se já tem permissão, faz login imediatamente
      await window.OneSignal.login(`upbot_${uid}`);
      console.log("External user ID configurado:", `upbot_${uid}`);
    } else {
      // Se não tem permissão, mostra o prompt
      console.log("Solicitando permissão para notificações...");
      await window.OneSignal.Notifications.showSlidedownPrompt();
    }
  } catch (error) {
    console.error("Erro na configuração do OneSignal para usuário:", error);
  }
};
